var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "footer",
    { staticStyle: { "background-color": "#f3f4f8" } },
    [
      _c(
        "div",
        {
          staticClass: "py-0 border-top border-bottom border-gray-400",
          staticStyle: { "background-color": "#fff" },
        },
        [
          _c("v-container", [
            _c(
              "ul",
              {
                staticClass:
                  "list-unstyled d-flex flex-wrap ps-0 justify-center",
              },
              _vm._l(
                _vm.$optional("data.footer_menu"),
                function (link, label, i) {
                  return _c(
                    "li",
                    {
                      key: i,
                      class: [
                        "py-2 pe-4 pe-md-7",
                        { "ps-md-3 ps-md-7": i !== 0 },
                      ],
                    },
                    [
                      _c(
                        "dynamic-link",
                        {
                          attrs: {
                            to: link,
                            "append-class": "text-reset fw-600 opacity-80",
                          },
                        },
                        [_vm._v(_vm._s(label))]
                      ),
                    ],
                    1
                  )
                }
              ),
              0
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-container",
        { staticClass: "pt-8 pb-14 pb-md-10 pb-lg-0" },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "8", md: "6", lg: "2" } },
                [
                  _c("div", { staticClass: "pb-7 border-gray-800 mb-6" }, [
                    _c("img", {
                      staticClass: "mw-100",
                      attrs: { src: _vm.data.footer_logo },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "mb-5",
                  attrs: { lg: "5", cols: "12", "offset-lg": "1" },
                },
                [
                  _c(
                    "ul",
                    { staticClass: "list-unstyled ps-0 fs-13 mb-3 opacity-80" },
                    [
                      _c("li", { staticClass: "py-1 fs-15 fw-700" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$optional("data.company_info?.company_name")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "py-1" }, [
                        _vm._v(
                          "본사 주소 : " +
                            _vm._s(
                              _vm.$optional(
                                "data.contact_info?.contact_address"
                              )
                            ) +
                            " "
                        ),
                        _c("span", { staticClass: "fs-11 px-2" }, [
                          _vm._v("|"),
                        ]),
                        _vm._v(
                          " 대표이사 : " +
                            _vm._s(_vm.$optional("data.company_info?.ceo_name"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "py-1" }, [
                        _vm._v(
                          "사업자번호 : " +
                            _vm._s(
                              _vm.$optional("data.company_info?.biz_number")
                            ) +
                            " "
                        ),
                        _c("span", { staticClass: "fs-10 px-2" }, [
                          _vm._v("|"),
                        ]),
                        _vm._v(
                          " 통신판매번호 : " +
                            _vm._s(
                              _vm.$optional(
                                "data.company_info?.online_sales_license_number"
                              )
                            )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "py-1" }, [
                        _vm._v(
                          "개인정보관리 책임자 : " +
                            _vm._s(
                              _vm.$optional(
                                "data.company_info?.privacy_manager"
                              )
                            ) +
                            " "
                        ),
                        _c("span", { staticClass: "fs-11 px-2" }, [
                          _vm._v("|"),
                        ]),
                        _vm._v(
                          " 이메일 : " +
                            _vm._s(
                              _vm.$optional("data.contact_info?.contact_email")
                            )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "py-1" }, [
                        _vm._v(
                          "연락처 : " +
                            _vm._s(
                              _vm.$optional("data.contact_info?.contact_phone")
                            ) +
                            " "
                        ),
                        _c("span", { staticClass: "fs-11 px-2" }, [
                          _vm._v("|"),
                        ]),
                        _vm._v(
                          " 팩스 : " +
                            _vm._s(
                              _vm.$optional("data.contact_info?.contact_fax")
                            )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "py-1" }, [
                        _vm._v(
                          "웹하드 : " +
                            _vm._s(
                              _vm.$optional("data.company_info?.webhard_id")
                            ) +
                            " / " +
                            _vm._s(
                              _vm.$optional("data.company_info?.webhard_pw")
                            )
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { staticClass: "mb-5", attrs: { lg: "4", cols: "12" } },
                [
                  _c("ul", { staticClass: "list-unstyled ps-0 fs-13 mb-3" }, [
                    _vm.data.contact_info?.factory1_address ||
                    _vm.data.contact_info?.factory1_address
                      ? _c("li", { staticClass: "py-1 fs-15 fw-700" }, [
                          _vm._v("공장"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.data.contact_info?.factory1_address
                      ? _c("li", { staticClass: "py-1" }, [
                          _vm._v(
                            "1공장 : " +
                              _vm._s(
                                _vm.$optional(
                                  "data.contact_info?.factory1_address"
                                )
                              )
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.data.contact_info?.factory2_address
                      ? _c("li", { staticClass: "py-1 mb-2" }, [
                          _vm._v(
                            "2공장 : " +
                              _vm._s(
                                _vm.$optional(
                                  "data.contact_info?.factory2_address"
                                )
                              )
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            { staticClass: "py-2" },
            [
              _c("v-col", { attrs: { cols: "12" } }, [
                _c("div", {
                  staticClass: "text-center lh-1 fs-13",
                  domProps: {
                    innerHTML: _vm._s(_vm.$optional("data.copyright_text")),
                  },
                }),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }